import { Fragment } from "react/jsx-runtime";
import { SectionHeading } from "~/components/DetailsPage/components";
import { CveRiskFactors } from "~/components/vulnerabilities/cve-risk-factors";
import { useFindingOnAsset } from "../../hooks";
import {
  isAdvisoryOrCveFinding,
  isCheckFinding,
  isGenericFinding,
} from "~/pages/findings/FindingOnAsset/utils";
import { EmptySection } from "~/components/vulnerabilities";

function getInsightsLabel(
  finding: ReturnType<typeof useFindingOnAsset>["finding"],
) {
  if (isAdvisoryOrCveFinding(finding)) return "Vulnerability";
  if (isGenericFinding(finding)) return "Finding";
  return "Check";
}

export function VulnerabilityInsights() {
  const { finding, riskFactorsWithDocs } = useFindingOnAsset();

  const label = getInsightsLabel(finding);

  const isEmpty =
    (isCheckFinding(finding) || isGenericFinding(finding)) &&
    riskFactorsWithDocs.length === 0
      ? true
      : isAdvisoryOrCveFinding(finding) &&
        !finding?.cvss &&
        !finding?.epss &&
        riskFactorsWithDocs.length === 0;

  return (
    <Fragment>
      <SectionHeading heading={`${label} insights`} />
      {isEmpty ? (
        <EmptySection
          id="no-risk-factors"
          text={`No risk factors found for this ${label.toLowerCase()}`}
        />
      ) : (
        <CveRiskFactors
          id="finding-risk-factors"
          cvssScore={isAdvisoryOrCveFinding(finding) ? finding?.cvss : null}
          epssScore={isAdvisoryOrCveFinding(finding) ? finding?.epss : null}
          riskFactors={riskFactorsWithDocs}
          RiskFactorsProps={{ hideValues: true }}
          CVSSProps={{ flipContent: true }}
          EPSSProps={{ flipContent: true }}
        />
      )}
    </Fragment>
  );
}
